<div class="flex flex-column h-full" style="max-height: 550px;">

    <div class="flex flex-column pb-0 w-full border-bottom-1 bg-white surface-border "
         style="position: sticky; top: 0; z-index: 1;"
    >
        <p class="m-0">Choose up to 3 favorite airlines so we can prioritize deals from them and use the data to help
            negotiate with those airlines for future member discounts.</p>
        <search-select
            #searchBox
            placeholder="Search Airlines"
            [currentCount]="airlines.length"
            [maxCount]="3"
            [existingIds]="airlines"
            [resultCap]="6"
            [searchFn]="searchAirlines"
            [idKey]="'id'"
            itemLabelSingular="airline"
            (added)="onAddAirline($event)">
        </search-select>
    </div>

    <!-- Display Dream Destination cards here -->
    <div class="overflow-auto no-scrollbar" style="flex: 1; min-height: 0;">
        <div class="grid pt-4 mx-0">
            <div class="col-6" *ngFor="let airline of airlines" (mouseenter)="hoveredAirlineId = airline.id"
                 (mouseleave)="hoveredAirlineId = null">
                <div class="relative">
                    <div
                        class="w-full bg-white flex justify-content-center align-items-center relative shadow-2"
                        style="
              aspect-ratio: 1;
              border-radius: var(--border-radius);
              overflow: hidden;
            "
                    >
                        <img
                            [src]="airline.image"
                            alt="{{airline.name}} logo"
                            style="max-width: 50%; max-height: 110%; object-fit: contain;"
                            [ngClass]="{'fallback-logo': airline.image.startsWith('/assets')}"
                        />
                    </div>


                    <p-tag
                        severity="success"
                        [rounded]="true"
                        styleClass="absolute top-0 right-0 mt-3 mr-3"
                        [style]="{ width: '22.75px', height: '22.75px' }"
                        (click)="removeAirline(airline)"
                    >
                        <i
                            class="cursor-pointer"
                            [ngClass]="hoveredAirlineId === airline.id
            ? 'ph ph-x text-black text-lg'
            : 'ph-fill ph-heart text-red-500 text-lg'"
                        ></i>
                    </p-tag>

                </div>
                <div class="flex flex-column gap-2 mt-2">
                    <h6 class="m-0">{{ airline.name }}</h6>
                </div>
            </div>
            <div class="col-6 cursor-pointer" (click)="searchBox.focusInput()" *ngIf="airlines.length < maxCount">
                <div class="relative">
                    <div
                    class="w-full surface-200 flex justify-content-center align-items-center relative"
                    style="
                      aspect-ratio: 1;
                      border-radius: var(--border-radius);
                      overflow: hidden;
                    "
                  >
                  <i class="ph ph-plus text-8xl text-white"></i>
                      </div>
                </div>
                <div class="flex flex-column gap-2 mt-2">
                    <h6 class="m-0">Add new airline</h6>
                </div>
            </div>
        </div>
    </div>

</div>

